import React, { Component } from 'react';
import './App.css';
import Header from './Components/Header';
import Footer from './Components/Footer';
import About from './Components/About';
import Resume from './Components/Resume';
import Contact from './Components/Contact';
import Extras from './Components/Extras';
import Portfolio from './Components/Portfolio';

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resumeData: null,
      loadError: false
    };
  }

  componentDidMount() {
    var dataUrl = '/resumeData.json';

    fetch(dataUrl)
      .then(function(response) {
        if (!response.ok) {
          throw new Error('Resume data could not be loaded.');
        }

        return response.json();
      })
      .then(function(data) {
        this.setState({ resumeData: data });
      }.bind(this))
      .catch(function(error) {
        console.error(error);
        this.setState({ loadError: true });
      }.bind(this));
  }

  renderLoadingState() {
    return (
      <main className="site-loading" role="status" aria-live="polite">
        <div>
          <p className="eyebrow">Raj Tandukar</p>
          <h1>Preparing resume profile</h1>
        </div>
      </main>
    );
  }

  renderErrorState() {
    return (
      <main className="site-loading site-loading-error">
        <div>
          <p className="eyebrow">Raj Tandukar</p>
          <h1>Resume profile is temporarily unavailable.</h1>
          <p>Please try refreshing the page.</p>
        </div>
      </main>
    );
  }

  render() {
    if (this.state.loadError) {
      return this.renderErrorState();
    }

    if (!this.state.resumeData) {
      return this.renderLoadingState();
    }

    var data = this.state.resumeData;

    return (
      <div className="App">
        <Header data={data.main} />
        <main>
          <About data={data.main} />
          <Resume data={data.resume} />
          <Portfolio data={data.portfolio} />
          <Extras data={data.Extras} />
          <Contact data={data.Contact} main={data.main} />
        </main>
        <Footer data={data.main} />
      </div>
    );
  }
}

export default App;
